const targetingLangugages = [
  { key: 0, text: 'Arabic', value: 28 },
  { key: 1, text: 'Chinese', value: 20 },
  { key: 2, text: 'English', value: 6 },
  { key: 3, text: 'Hindi', value: 46 },
  { key: 4, text: 'Korean', value: 12 },
  { key: 5, text: 'Portuguese', value: 16 },
  { key: 6, text: 'Punjabi', value: 47 },
  { key: 7, text: 'Russian', value: 17 },
  { key: 8, text: 'Spanish', value: 23 },
  { key: 9, text: 'Turkish', value: 19 },
  { key: 10, text: 'Urdu', value: 90 },
];

export default targetingLangugages;



// WEBPACK FOOTER //
// ./src/components/common/TargetingLanguages.js